<template>
  <ActionIcon
    :action-fn="_deleteFn"
    :cell-data="cellData"
    :tooltip-position="tooltipPosition"
    :tooltip="formattedTooltip"
    :is-multilined-tooltip="isMultilinedTooltip"
    :disabled="disabled"
    icon="trash"
    :data-e2e="TableCypressAttribute.buttons.DELETE"
  />
</template>

<script>
import ActionIcon from '/@/modules/core/app/components/ActionIcon.vue';
import ModalService from '/@/modules/core/ui/services/ModalService';
import { ActionCellMixin } from '/@/modules/core/table/mixins/ActionCellMixin';
import DeleteCellModal from '/@/modules/core/table/components/DeleteCellModal.vue';
import { TableCypressAttribute } from '/@/modules/core/table/constants/TableCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ActionCellDelete',
  mixins: [ActionCellMixin],
  components: { ActionIcon },
  props: {
    deleteFn: {
      type: Function,
      required: false
    },
    deleteSuccessText: {
      type: String,
      required: false
    },
    tooltip: { type: String },
    tooltipPosition: { type: String },
    disabled: { type: Boolean, default: false },
    isMultilinedTooltip: { type: Boolean }
  },
  static: {
    TableCypressAttribute
  },
  computed: {
    formattedTooltip() {
      return this.tooltip ?? this.$t('core.delete');
    }
  },
  methods: {
    _deleteFn() {
      if (this.deleteFn) {
        this.deleteFn(this.$props);
      } else {
        ModalService.show({
          parent: this,
          component: DeleteCellModal,
          props: this.$props
        });
      }
    }
  }
};
</script>
